import { tabsAnatomy as parts } from '@chakra-ui/anatomy';
import type { StyleFunctionProps } from '@chakra-ui/react';
import type { ComponentStyleConfig } from '@chakra-ui/theme';
import { theme as defaultTheme } from '@chakra-ui/theme';
import type { PartsStyleFunction } from '@chakra-ui/theme-tools';

const variantRepublicLine: PartsStyleFunction<typeof parts> = (props) => ({
  ...lineVariant(props),

  tablist: {
    ...lineVariant(props)?.tablist,
    borderBottomColor: 'grey.100',
    borderBottomWidth: '2px',
  },

  tab: {
    ...lineVariant(props)?.tab,
    padding: '15px 20px 8px',
    color: 'grey.500',
    fontWeight: '500',

    _selected: {
      ...lineVariant(props)?.tab._selected,
      fontWeight: '700',
      color: 'blue.500',
      borderColor: 'blue.500',
    },
  },

  tabpanel: {
    px: 0,
  },
});

export const Tabs: ComponentStyleConfig = {
  baseStyle: {
    indicator: {
      bg: 'blue.500',
      height: '2px',
      mt: '-2px',
    },
    root: {
      display: 'block',
    },
    tab: {
      _disabled: {
        color: 'grey.300',
        cursor: 'not-allowed',
        opacity: 0.4,
      },
      _focusVisible: {
        boxShadow: '0 0 0 1px white, 0 0 0 3px #6691FF',
        outline: 0,
        zIndex: 1,
      },
      _selected: {
        color: 'blue.500',
      },
      color: 'grey.600',
      flex: undefined,
      fontWeight: 'bold',
      transitionDuration: 'normal',
      transitionProperty: 'common',
    },
    tablist: {
      borderBottom: '1px solid',
      borderColor: 'grey.100',
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
    tabpanel: {
      p: 4,
    },
  },
  variants: {
    'republic-line': variantRepublicLine,
  },
};

function lineVariant(props: StyleFunctionProps) {
  return defaultTheme.components.Tabs.variants?.line(props);
}
